import {Component, EventEmitter, Output} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Customer} from "../customer";
import {CustomerService} from "../customer-service.service";
import {Observable} from "rxjs/Observable";
import {HttpErrorResponse} from "@angular/common/http";
import {errorObject} from "rxjs/util/errorObject";

@Component({
  selector: 'app-customer-form',
  templateUrl: './customer-form.component.html',
  styleUrls: ['./customer-form.component.css']
})
export class CustomerFormComponent {

  customer: Customer;
  id: string;
  action: string;
  myError: string;
  stop: string;

  @Output() refresh = new EventEmitter();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private customerService: CustomerService) {
    this.customer = new Customer();
    this.id = route.snapshot.params['customerId'];
    this.action = route.snapshot.params['action'];
    this.myError = "";
    this.stop = "";
  }

  ngOnInit() {
    if (this.action.localeCompare("edit") == 0) {
      this.customerService.findById(this.id).subscribe(data => this.customer = data, error => {this.stop = "1"; this.myError = "Customer not found"});
    }
  }

  onSubmit() {
    if (this.action.localeCompare("add") == 0) {
      this.customerService.save(this.customer, this).subscribe(result => this.gotoCustomerList(), error => this.refresh.emit());
    } else {
      this.customerService.update(this.customer, this).subscribe(result => this.gotoCustomerList(), error => this.refresh.emit());
    }
  }

  gotoCustomerList() {
    this.router.navigate(['/customers']);
  }

}



// WEBPACK FOOTER //
// ./src/app/customer-form/customer-form.component.ts